const VUE_APP_API_IAPETUS_URL = document.querySelector("html").getAttribute("api_iapetus_url");

export default VUE_APP_API_IAPETUS_URL